import React from 'react';
import SpinnerLoader from './../spinnerLoader/spinnerLoader';
import { Link } from 'react-router-dom';

import './css/index.scss';

class Artist extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      slug: null,
      artist: '',
    };
  }

  componentDidMount(){
    this.setState({slug: this.props.match.params.slug}, () => {
      this.props.getArtistTabs(this.props.match.params.slug);
    });
  }

  componentDidUpdate(){
    if(this.props.match.params.slug !== this.state.slug)
    {
      this.setState({slug: this.props.match.params.slug}, () => {
        this.props.getArtistTabs(this.props.match.params.slug);
      });
    }
    if(this.props.artistTabs !== null)
    {
      if(this.state.artist !== this.props.artistTabs.artist.name)
      {
        this.setState({artist:this.props.artistTabs.artist.name}, ()=>{
          document.title = "Taburi.ro - " + this.props.artistTabs.artist.name;
        });
      }
    }
  }

  componentWillUnmount(){
    this.props.clearArtistTabs();
  }

  render () {
    return (
      <div className="artistContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-200px'}}>
            {this.props.artistTabs !== null ? 
            (
              <div>
                <h1>{this.props.artistTabs.artist.name}</h1>
                <div>
                  {this.props.artistTabs.tabs.length > 0 ? 
                   (<div>
                     {this.props.artistTabs.tabs.map((tab) => {
                       return <Link key={`aTli${tab.id}`} className="regularLink" to={`/tabulatura/${tab.id}/${this.props.artistTabs.artist.name.replace(/\s+/g, '-')}/${tab.title.replace(/\s+/g, '-')}`}>{tab.title}</Link>;
                     })}
                   </div>)
                   :
                    (<div>Din păcate nu sunt disponibile tabulaturi pentru acest artist. Poți contribui cu o tabulatură <Link className="regularLinkB" to={`/adauga-tabulatura`}>aici</Link>.</div>)
                  }
                </div>
              </div>
            )
            :
            (<SpinnerLoader />)}
            
          </div>
        </div>
      </div>
    );
  }
}

export default Artist;



// WEBPACK FOOTER //
// ./src/components/artist/artist.js